import React from "react";
import { Link } from "react-router-dom";
import Glyph from "./navGlyphs";

/*
 * WHAT THE CALENDAR TAB BECAME. The after-hours reply, the no-show rescue and
 * the booking page each used to carry their own Calendar tab; the rules now
 * live once, on Meetings ▸ Availability, and each of those pages says so in one
 * line (Navigation.dc.html, screen 04).
 */
export default function AvailabilityLink() {
  return (
    <Link to="/meetings/availability" className="crm-avail-link">
      <Glyph name="calendar" size={17} />
      <span className="crm-avail-link__text">
        Offers times from your availability <span>· shared with everything that proposes a meeting</span>
      </span>
      <span className="crm-avail-link__go">edit →</span>
    </Link>
  );
}
